module.exports = __webpack_public_path__ + "static/img/b1-2-3.ad596e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-2-3.png
// module id = zHvb
// module chunks = 1